import {Paper, PaperProps} from "../../paper/Paper/Paper";
import {Group, LoadingOverlay, rem, Text} from "@mantine/core";
import {createContentStyles} from "../../../theme/useContentStyles";
import {IconChartHistogram, IconCoin, IconFlag, TablerIconsProps,} from '@tabler/icons-react';
import {PropsWithChildren, ReactElement} from "react";

const useStyles = createContentStyles((theme) => ({
    value: {
        fontSize: rem(24),
        fontWeight: 700,
        lineHeight: 1,
    },
    diff: {
        lineHeight: 1,
        display: "flex",
        alignItems: "center",
    },
    icon: {
        color: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.dark[3]
    },
    title: {
        fontWeight: 700,
        textTransform: "uppercase"
    }
}));

const ALL_ICON_TYPES = [
    "coin",
    "chartHistogram",
    "flag"
] as const

export type InsightIconType = typeof ALL_ICON_TYPES[number]

const icons: Record<InsightIconType, (props: TablerIconsProps) => ReactElement> = {
    coin: IconCoin,
    chartHistogram: IconChartHistogram,
    flag: IconFlag,
};

export type InsightContainerProps = Omit<PaperProps, 'pos'> & {
    title: string;
    icon?: InsightIconType
    loading?: boolean
}

export const InsightContainer = (props: PropsWithChildren<InsightContainerProps>) => {
    const {
        title,
        icon = "chartHistogram",
        loading = false,
        p = "md",
        radius = "md",
        withBorder = true,
        children,
        ...rest
    } = props

    const {classes} = useStyles();

    const Icon = icons[icon];

    return (
        <Paper {...rest} withBorder={withBorder} p={p} radius={radius} key={title} pos="relative">
            <LoadingOverlay visible={loading} overlayBlur={1}/>
            <Group position="apart">
                <Text size="xs" c="dimmed" className={classes.title}>
                    {title}
                </Text>
                <Icon className={classes.icon} size="1.4rem" stroke={1.5}/>
            </Group>

            {children}
        </Paper>
    );
}
